import { Component, computed, effect, EventEmitter, inject, Output, signal } from '@angular/core';
import { take } from 'rxjs';
import { BriefService } from '../../../../services/brief/brief.service';
import { ManageBriefTabsService } from '../../service/manage-brief-tabs/manage-brief-tabs.service';
import { ApplicationStatusEnum } from '../../../../common/general-types/briefs.dto';
import { FeedInvitedComponent } from './feed-invited/feed-invited.component';
import { FeedHiredComponent } from './feed-hired/feed-hired.component';
import { FeedAppliedComponent } from './feed-applied/feed-applied.component';
import { FeedCreatedComponent } from './feed-created/feed-created.component';
import { CreatorProfileComponent } from '../../../creators/molecules/creator-profile/creator-profile.component';
import { MagicSearchService } from '../../../creators/service/magic-search/magic-search.service';
import { FeedStartedComponent } from './feed-started/feed-started.component';
import { FeedVqaExtractedComponent } from './feed-vqa-extracted/feed-vqa-extracted.component';
import { FeedAutoPilotOnComponent } from './feed-auto-pilot-on/feed-auto-pilot-on.component';
import { FeedAutoPilotOffComponent } from './feed-auto-pilot-off/feed-auto-pilot-off.component';
import { ChoosePlanService } from '../../../choose-plan/service/choose-plan/choose-plan.service';
import { FeedReadyToPostComponent } from './feed-ready-to-post/feed-ready-to-post.component';
import { FeedPostedComponent } from './feed-posted/feed-posted.component';

@Component({
  selector: 'mbt-activity-feed',
  standalone: true,
  imports: [FeedInvitedComponent, FeedAppliedComponent, FeedHiredComponent, 
    FeedCreatedComponent, CreatorProfileComponent, FeedStartedComponent,
    FeedVqaExtractedComponent, FeedAutoPilotOnComponent, FeedAutoPilotOffComponent,
     FeedReadyToPostComponent, FeedPostedComponent
  ],
  templateUrl: './activity-feed.component.html',
  styleUrl: './activity-feed.component.css'
})
export class ActivityFeedComponent {

  @Output() goToTab = new EventEmitter<{ tab: number, subTab: number }>();
  @Output() refreshBriefOut = new EventEmitter<void>(); 

  protected readonly ApplicationStatusEnum = ApplicationStatusEnum;

  /** Services */
  public magicSearchService = inject(MagicSearchService);
  public choosePlanService = inject(ChoosePlanService);
  /** Services END */

  briefActivityFeed = signal<any[] | undefined>(undefined);

  /** Unique dates with their activities for display (one date row per day) */
  activityFeedByDate = computed(() => {
    const feed = this.briefActivityFeed();
    if (!feed || feed.length === 0) return [];
    const byDate = new Map<string, { dateLabel: string; activities: any[] }>();
    const todayKey = new Date().toISOString().split('T')[0];
    for (const activity of feed) {
      const d = activity.date ? new Date(activity.date) : new Date();
      const key = d.toISOString().split('T')[0];
      const dateLabel = key === todayKey ? 'Today' : d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
      if (!byDate.has(key)) {
        byDate.set(key, { dateLabel, activities: [] });
      }
      byDate.get(key)!.activities.push(activity);
    }
    return Array.from(byDate.values());
  });

  /** Services */
  private briefService = inject(BriefService);
  public manageBriefTabsService = inject(ManageBriefTabsService);
  /** Services END */

  constructor() {
    effect(() => {
      const briefId = this.manageBriefTabsService.focussedBrief()?.id;
      if (briefId) {
        this.getBriefActivityFeed();
      } else {
        this.briefActivityFeed.set(undefined);
      }
    });
  }

  getBriefActivityFeed() {
    const briefId = this.manageBriefTabsService.focussedBrief()?.id;
    if (!briefId) {
      return;
    }
    this.briefService.getBriefActivityFeed(briefId).pipe(take(1)).subscribe({
      next: (response: any) => {
        console.log('Brief Activity Feed: ', response);
        this.briefActivityFeed.set(response);
      },
      error: (err: any) => {
        console.error('err: ', err);
      }
    });
  }

  viewInvites(event: { tab: number, subTab: number }) {
    this.goToTab.emit(event);
  }
  
  viewApplicants(event: { tab: number, subTab: number }) {
    this.goToTab.emit(event);
  }

  viewHires(event: { tab: number, subTab: number }) {
    this.goToTab.emit(event);
  }

  refreshBrief() {
    this.getBriefActivityFeed();
  }
}
